import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Market from './Market';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, requestedItems: data, totalPage, currentPage,
  } = state.market;
  return {
    isLoading,
    data,
    totalPage,
    currentPage,
  };
}

const Styled = withStyles(styles)(Market);

export default connect(
  mapStateToProps,
)(Styled);
